module.exports = __webpack_public_path__ + "static/banner-799364a6b33c5d329484a7b1ab6ab4ee.png";